<template>
    <content-search-field :isSimpleSearchField="true"></content-search-field>
</template>
<script setup lang="ts">
import { emitterInstance } from '@/classes/emitter';
import { onBeforeMount, ref } from 'vue';
import ContentSearchField from '../searchOverlay/content-search-field.vue';

    const isActive = ref(false);

    const toggleSearchOverlay = () =>{
        isActive.value=!isActive.value;
        const scrollPos = window.pageYOffset;
        const contentContainer = document.querySelector('.suchformularContentContainer');
        const body = document.querySelector('body');
        const navbar = document.querySelector('.ff-navbar');

        if (isActive.value) {
            contentContainer?.classList.add("visible");
            contentContainer?.classList.add("menu-sticky");
            navbar?.classList.add("menu-sticky");
            body?.classList.add('overlay-active');
        } else {
            contentContainer?.classList.remove("visible");
            body?.classList.remove('overlay-active');
            if (scrollPos < 120) {
                contentContainer?.classList.remove("menu-sticky");
                navbar?.classList.remove("menu-sticky");
            }
        }    
        emitterInstance.emit('showSearchOverlay', isActive.value);
    }

    onBeforeMount(()=> {
        emitterInstance.on('toggleSimpleSearch', (event)=> {
            //nur ausführen wenn inactive und event true            
            if(!isActive.value && (event)){
                toggleSearchOverlay();
                emitterInstance.emit("updateSearchTerm", event);
                emitterInstance.emit("contentSearch", event);
            }
        })
    });
</script>